import { ROUTES } from './const'

const routes = [
  {
    path: '/',
    name: ROUTES.APP,
    redirect: '/' + ROUTES.AUTH,
  },

  // Auth layout — wraps all auth-related routes with AuthPageLayout
  {
    path: '/',
    component: () => import('src/layouts/AuthLayout.vue'),
    children: [
      // SSO magic link entry point (/sso/:tenant) and SSO Auth0 callback (/sso)
      {
        path: ROUTES.SSO + '/:tenant?',
        name: ROUTES.SSO,
        component: () => import('src/pages/SsoEntry.vue'),
      },

      // Direct provider login (Google, Microsoft) — bypasses login screen
      {
        path: ROUTES.DIRECT + '/:provider',
        name: ROUTES.DIRECT,
        component: () => import('src/pages/DirectEntry.vue'),
      },

      // Auth callback and login flow
      {
        path: ROUTES.AUTH,
        name: ROUTES.AUTH,
        component: () => import('src/pages/RouterIndex.vue'),
      },
    ],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
]

export default routes
